import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-[15px] font-bold text-textPrimary" }, " Declare o horário que este anexo comprova ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mt-0.5 text-[12.5px] text-neutral50" }, [
  /*#__PURE__*/_createTextVNode(" Começamos com o horário previsto do plantão. "),
  /*#__PURE__*/_createElementVNode("strong", null, "Digite por cima"),
  /*#__PURE__*/_createTextVNode(" para informar o horário real que aparece no anexo. ")
], -1)
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = { class: "flex flex-wrap items-center justify-between gap-2" }
const _hoisted_5 = { class: "min-w-0 text-[13px] text-neutral50" }
const _hoisted_6 = { class: "text-sm font-bold text-textPrimary" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["name", "value", "checked", "aria-describedby", "data-testid", "onChange"]
const _hoisted_9 = {
  key: 0,
  class: "h-[9px] w-[9px] rounded-full bg-primary30"
}
const _hoisted_10 = { class: "min-w-0" }
const _hoisted_11 = { class: "block text-[13.5px] text-textPrimary" }
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "mt-1.5 inline-flex gap-[3px]" }
const _hoisted_14 = { class: "mt-3.5 grid gap-3 sm:grid-cols-2" }
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "font-normal text-neutral50" }
const _hoisted_17 = ["id", "value", "disabled", "aria-describedby", "data-testid", "onInput"]
const _hoisted_18 = { class: "flex-none text-xs text-neutral50" }
const _hoisted_19 = ["id", "data-testid"]
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id", "data-testid"]
const _hoisted_22 = ["id"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "md:hidden" }, "acima", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:inline" }, "ao lado", -1)
const _hoisted_25 = ["id"]
const _hoisted_26 = ["data-testid"]
const _hoisted_27 = ["data-testid", "onClick"]
const _hoisted_28 = ["for"]
const _hoisted_29 = ["id", "value", "data-testid", "onChange"]
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  class: "mt-3 border-t border-dashed border-lightGray30 pt-2.5 text-[12.5px] text-neutral50",
  "data-testid": "send-record-system-has"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "O sistema tem", -1)
const _hoisted_33 = { class: "w-[76px] flex-none" }
const _hoisted_34 = { class: "w-11 flex-none tabular-nums text-textPrimary" }
const _hoisted_35 = { class: "flex-1" }
const _hoisted_36 = { class: "flex-none font-bold" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 text-xs text-neutral50" }, " Guardamos o horário declarado, quem declarou e a data. Se o auditor sobrescrever na auditoria, o valor declarado continua visível no histórico ao lado do valor final. ", -1)

import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { mdiLoginVariant, mdiLogoutVariant } from '@mdi/js'
import {
  CoveredLegs,
  EffectiveRegistrationStatus,
  EFFECTIVE_REGISTRATION_STATUS_LABELS,
  EFFECTIVE_SOURCE_KIND_LABELS
} from '@/constants/ds-attendance.constants'
import { timezones } from '@/hooks/useCommon'
import { DESKTOP_MEDIA_QUERY, useMediaQuery } from '@/hooks/useMediaQuery'
import { DEFAULT_UTC_OFFSET, formatDateInOffset } from '@/utils/date'
import AttachmentPanel from './AttachmentPanel.vue'
import {
  applyTimeInputToIso,
  buildToleranceWarnings,
  isLegTimeMissing,
  isoToTimeInput,
  type NormalizedPrefillItem,
  type SendRecordLine,
  type ToleranceWarning
} from './types'

/**
 * Passo 4 de M2 — o coração do fluxo. O emissor declara O QUE ESTE REGISTRO
 * SUBSTITUI (check-in, check-out ou ambos) e com que horário. Pré-preenchido com
 * o PREVISTO do plantão (Q5) e não com o efetivo: pré-preencher com o efetivo
 * faria o emissor repetir o que já existe.
 *
 * M6 (17/09) reformou a tela depois do primeiro uso em PROD: os horários pareciam
 * texto, o foco não chegava em campo nenhum, o anexo tinha ficado na etapa 3 e as
 * três pernas estavam escondidas num select.
 */

type TimeField = 'declaredCheckin' | 'declaredCheckout'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepEquivalence',
  props: {
    prefill: {},
    lines: {},
    checkinLateToleranceMinutes: {},
    checkoutEarlyToleranceMinutes: {},
    files: { default: () => [] },
    activeIndex: { default: null }
  },
  emits: ["update:lines", "update:activeIndex"],
  setup(__props: any, { emit }) {

const props = __props;



/**
 * Não há `update:typing`: quem monta o painel do anexo é ESTE passo, então o
 * estado de digitação (que vira o recorte do ⑫ no celular) nasce e morre aqui.
 * Exportá-lo criaria uma cópia no modal que ninguém leria.
 */


const LEG_OPTIONS: Array<{
  value: CoveredLegs
  label: string
  help: string
  bars: [boolean, boolean]
}> = [
  {
    value: CoveredLegs.BOTH,
    label: 'Entrada e saída',
    help: 'O anexo comprova o plantão inteiro. Libera os dois horários.',
    bars: [true, true]
  },
  {
    value: CoveredLegs.CHECKIN,
    label: 'Só a entrada',
    help: 'Só o check-in. A saída continua como o sistema tem hoje.',
    bars: [true, false]
  },
  {
    value: CoveredLegs.CHECKOUT,
    label: 'Só a saída',
    help: 'Só o check-out. A entrada continua como o sistema tem hoje.',
    bars: [false, true]
  }
]

const TIME_LEGS = [
  {
    field: 'declaredCheckin' as const,
    covered: CoveredLegs.CHECKIN,
    label: 'Check-in',
    testidPrefix: 'send-record-checkin'
  },
  {
    field: 'declaredCheckout' as const,
    covered: CoveredLegs.CHECKOUT,
    label: 'Check-out',
    testidPrefix: 'send-record-checkout'
  }
]

const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

const prefillById = computed(
  () => new Map(props.prefill.map((item) => [item.doctorStationId, item]))
)

function itemOf(line: SendRecordLine): NormalizedPrefillItem | undefined {
  return prefillById.value.get(line.doctorStationId)
}

function covers(line: SendRecordLine, leg: CoveredLegs): boolean {
  return line.coveredLegs === leg || line.coveredLegs === CoveredLegs.BOTH
}

function toTimeInput(value: string | null, offset: string): string {
  return isoToTimeInput(value, offset)
}

/* ----------------------------------------------------------------------- *
 * Cabeçalho do cartão
 * ----------------------------------------------------------------------- */

function headOf(line: SendRecordLine): string {
  return itemOf(line)?.doctorName ?? `Plantão #${line.doctorStationId}`
}

/** `· Qui 17/09/2026 · previsto 07:00–13:00 · Enfermaria 1` */
function whenOf(line: SendRecordLine): string {
  const item = itemOf(line)
  if (!item) return ''
  const day = formatDayWithWeekday(item.expectedStart, item.timezone)
  const expected =
    item.expectedStart && item.expectedEnd
      ? `previsto ${isoToTimeInput(item.expectedStart, item.timezone)}–${isoToTimeInput(item.expectedEnd, item.timezone)}`
      : ''
  return [day, expected, item.healthUnitName]
    .filter(Boolean)
    .map((part) => `· ${part}`)
    .join(' ')
}

/**
 * Dia lido NO FUSO DA ESCALA — nunca no do navegador, a mesma regra dos horários.
 * O `Date.UTC` sobre a data já deslocada devolve o dia da semana sem reintroduzir
 * o fuso da máquina.
 */
function formatDayWithWeekday(iso: string | null, offset: string): string {
  if (!iso) return ''
  const formatted = formatDateInOffset(iso, offset)
  if (!formatted) return ''
  const [day, month, year] = formatted.split('/').map(Number)
  const weekday = WEEKDAYS[new Date(Date.UTC(year, month - 1, day)).getUTCDay()] ?? ''
  return `${weekday} ${formatted}`.trim()
}

/** Chip do cabeçalho: o estado efetivo do plantão, resumido (M1, balão ①). */
function stateOf(line: SendRecordLine): { label: string; classes: string } {
  const effective = itemOf(line)?.effective
  const neutral = 'bg-gray-100 text-neutral50'
  if (!effective) {
    return {
      label: EFFECTIVE_REGISTRATION_STATUS_LABELS[EffectiveRegistrationStatus.PENDING],
      classes: neutral
    }
  }

  switch (effective.registrationStatus) {
    case EffectiveRegistrationStatus.OK:
      return { label: 'Registro OK', classes: 'bg-green-50 text-sucess' }
    case EffectiveRegistrationStatus.PARTIAL:
      return {
        label: effective.checkout ? 'Falta só o check-in' : 'Falta só o check-out',
        classes: 'bg-orange-50 text-[#B45F09]'
      }
    case EffectiveRegistrationStatus.PENDING:
      return { label: 'Pendente', classes: neutral }
    default:
      return { label: 'Sem registro nas duas pernas', classes: 'bg-red-50 text-negative' }
  }
}

/* ----------------------------------------------------------------------- *
 * Horários
 * ----------------------------------------------------------------------- */

function expectedOf(line: SendRecordLine, field: 'declaredCheckin' | 'declaredCheckout'): string {
  const item = itemOf(line)
  const expected = field === 'declaredCheckin' ? item?.expectedStart : item?.expectedEnd
  return isoToTimeInput(expected ?? null, line.timezone) || '—'
}

function patch(doctorStationId: number, patchValue: Partial<SendRecordLine>): void {
  emit(
    'update:lines',
    props.lines.map((line) =>
      line.doctorStationId === doctorStationId ? { ...line, ...patchValue } : line
    )
  )
}

/** Horário zerado ao escolher uma perna única — a rede de segurança do "voltar a ambos". */
const clearedTimes = new Map<number, Partial<Record<TimeField, string | null>>>()

function remember(doctorStationId: number, field: TimeField, value: string | null): void {
  if (!value) return
  clearedTimes.set(doctorStationId, { ...clearedTimes.get(doctorStationId), [field]: value })
}

/**
 * De volta às duas pernas, a que tinha sido zerada volta ao PREVISTO (Q5) — nunca
 * ao efetivo, que faria o emissor repetir o que o sistema já tem. Prefill sem
 * previsto (backend antigo, plantão sem horário) cai no que a linha tinha ANTES de
 * ser zerada: pior que um horário para conferir é um campo vazio que trava o
 * "Próximo" sem dizer por quê.
 */
function restoreTime(line: SendRecordLine, field: TimeField): string | null {
  const item = prefillById.value.get(line.doctorStationId)
  const expected = field === 'declaredCheckin' ? item?.expectedStart : item?.expectedEnd
  return expected ?? clearedTimes.get(line.doctorStationId)?.[field] ?? null
}

/** Trocar a perna leva o foco para o campo que acabou de ficar ativo (③ + Q2). */
function updateLeg(doctorStationId: number, coveredLegs: CoveredLegs): void {
  const line = props.lines.find((item) => item.doctorStationId === doctorStationId)
  const patchValue: Partial<SendRecordLine> = { coveredLegs }

  if (coveredLegs === CoveredLegs.BOTH) {
    if (line && !line.declaredCheckin)
      patchValue.declaredCheckin = restoreTime(line, 'declaredCheckin')
    if (line && !line.declaredCheckout)
      patchValue.declaredCheckout = restoreTime(line, 'declaredCheckout')
  } else {
    // O anexo comprova UMA perna: deixar o horário da outra na tela (mesmo cinza e
    // desabilitado) fazia a pessoa achar que ela também estava sendo declarada.
    // Zerado, o campo mostra o "--:--" do próprio navegador e a dica explica o resto.
    const dropped: TimeField =
      coveredLegs === CoveredLegs.CHECKIN ? 'declaredCheckout' : 'declaredCheckin'
    remember(doctorStationId, dropped, line?.[dropped] ?? null)
    patchValue[dropped] = null
  }

  patch(doctorStationId, patchValue)
  focusLeg(doctorStationId, coveredLegs)
}

function updateTime(
  doctorStationId: number,
  field: 'declaredCheckin' | 'declaredCheckout',
  event: Event
): void {
  const item = prefillById.value.get(doctorStationId)
  const base = field === 'declaredCheckin' ? item?.expectedStart : item?.expectedEnd
  const current = props.lines.find((line) => line.doctorStationId === doctorStationId)
  const reference = base ?? current?.[field] ?? null
  patch(doctorStationId, {
    [field]: applyTimeInputToIso(
      reference,
      (event.target as HTMLInputElement).value,
      current?.timezone
    )
  })
}

function warningsOf(line: SendRecordLine): ToleranceWarning[] {
  const item = itemOf(line)
  return buildToleranceWarnings({
    line,
    expectedStart: item?.expectedStart ?? null,
    expectedEnd: item?.expectedEnd ?? null,
    checkinLateToleranceMinutes:
      item?.checkinLateToleranceMinutes ?? props.checkinLateToleranceMinutes,
    checkoutEarlyToleranceMinutes:
      item?.checkoutEarlyToleranceMinutes ?? props.checkoutEarlyToleranceMinutes
  })
}

function warningFor(line: SendRecordLine, leg: CoveredLegs): ToleranceWarning | undefined {
  if (!covers(line, leg)) return undefined
  return warningsOf(line).find((warning) => warning.leg === leg)
}

/* ----------------------------------------------------------------------- *
 * Fuso
 * ----------------------------------------------------------------------- */

/**
 * Lista de fusos do cadastro de escala (`useCommon`), para o seletor não inventar
 * um vocabulário próprio. Um fuso vindo da escala que não esteja na lista entra
 * como opção extra: nunca some do seletor o valor que está sendo enviado.
 */
const timezoneOptions = computed(() => {
  const known = new Set(timezones.map((zone) => zone.value))
  const extras = props.lines
    .map((line) => line.timezone)
    .filter((value): value is string => Boolean(value) && !known.has(value))
    .map((value) => ({ title: 'Fuso da escala', subtitle: value, value }))
  return [...timezones, ...extras]
})

function zoneTitle(offset: string): string {
  return timezones.find((zone) => zone.value === offset)?.title ?? 'fuso da escala'
}

/** Diz se o fuso mostrado ainda é o que veio da escala ou um escolhido à mão. */
function timezoneOrigin(line: SendRecordLine): string {
  const scheduleTimezone = itemOf(line)?.timezone
  return !scheduleTimezone || scheduleTimezone === line.timezone
    ? ''
    : ` — a escala é UTC${scheduleTimezone}`
}

const openedZones = ref<number[]>([])

/**
 * O seletor nasce ABERTO quando o fuso já não é o óbvio: a linha foi declarada
 * em outro fuso, ou a própria escala está fora de Brasília. Nos demais casos ele
 * só aparece depois do "Alterar" (Q4).
 */
function isZoneOpen(line: SendRecordLine): boolean {
  if (openedZones.value.includes(line.doctorStationId)) return true
  const scheduleTimezone = itemOf(line)?.timezone
  if (scheduleTimezone && scheduleTimezone !== line.timezone) return true
  return (scheduleTimezone ?? line.timezone) !== DEFAULT_UTC_OFFSET
}

function openZone(doctorStationId: number): void {
  if (!openedZones.value.includes(doctorStationId)) openedZones.value.push(doctorStationId)
}

/**
 * Trocar o fuso preserva os DÍGITOS digitados e troca só o offset: quem viu 08:00
 * na tela declarou 08:00 na unidade, e o que muda é em que fuso esse 08:00 vale.
 */
function updateTimezone(doctorStationId: number, event: Event): void {
  const timezone = (event.target as HTMLSelectElement).value
  const line = props.lines.find((item) => item.doctorStationId === doctorStationId)
  if (!line) return

  const checkin = isoToTimeInput(line.declaredCheckin, line.timezone)
  const checkout = isoToTimeInput(line.declaredCheckout, line.timezone)

  patch(doctorStationId, {
    timezone,
    declaredCheckin: checkin
      ? applyTimeInputToIso(line.declaredCheckin, checkin, timezone)
      : line.declaredCheckin,
    declaredCheckout: checkout
      ? applyTimeInputToIso(line.declaredCheckout, checkout, timezone)
      : line.declaredCheckout
  })
}

/* ----------------------------------------------------------------------- *
 * "O sistema tem"
 * ----------------------------------------------------------------------- */

function systemLegsOf(line: SendRecordLine) {
  const item = itemOf(line)
  if (!item) return []
  return [
    {
      key: 'checkin',
      label: 'Check-in',
      time: isoToTimeInput(item.effective.checkin, item.timezone),
      detail: detail(item.effective.checkinSource, item.expectedStart, item.timezone),
      status: legStatus(item.effective.checkin)
    },
    {
      key: 'checkout',
      label: 'Check-out',
      time: isoToTimeInput(item.effective.checkout, item.timezone),
      detail: detail(item.effective.checkoutSource, item.expectedEnd, item.timezone),
      status: legStatus(item.effective.checkout)
    }
  ]
}

function detail(
  source: keyof typeof EFFECTIVE_SOURCE_KIND_LABELS | null,
  expected: string | null,
  offset: string
): string {
  const sourceLabel = source ? EFFECTIVE_SOURCE_KIND_LABELS[source] : 'Nenhuma fonte'
  const expectedLabel = expected ? ` · previsto ${isoToTimeInput(expected, offset)}` : ''
  return `${sourceLabel}${expectedLabel}`
}

function legStatus(value: string | null): string {
  return value
    ? EFFECTIVE_REGISTRATION_STATUS_LABELS[EffectiveRegistrationStatus.OK]
    : EFFECTIVE_REGISTRATION_STATUS_LABELS[EffectiveRegistrationStatus.NONE]
}

/* ----------------------------------------------------------------------- *
 * Dica de tolerância do painel do anexo (⑤)
 * ----------------------------------------------------------------------- */

const toleranceHint = computed(() => {
  const candidates = [
    props.checkinLateToleranceMinutes,
    props.checkoutEarlyToleranceMinutes,
    ...props.prefill.flatMap((item) => [
      item.checkinLateToleranceMinutes,
      item.checkoutEarlyToleranceMinutes
    ])
  ].filter((value): value is number => typeof value === 'number')

  const window = candidates.length
    ? `Diferenças até ${Math.max(...candidates)} min entram como “dentro da tolerância”`
    : 'Diferenças pequenas entram como “dentro da tolerância”'

  return (
    `Compare o horário do anexo com o que você digitou. ${window}; ` +
    'acima disso o registro segue, marcado como divergente para a auditoria.'
  )
})

/* ----------------------------------------------------------------------- *
 * Foco e teclado (balões ① e ⑧ / Q2)
 * ----------------------------------------------------------------------- */

const timeInputs = new Map<string, HTMLInputElement>()
const activeLineId = ref<number | null>(props.lines[0]?.doctorStationId ?? null)
const isTyping = ref(false)
/** Painel preso ao topo no celular — é a altura dele que esconderia o campo. */
const mobilePanel = ref<HTMLElement | null>(null)

/** Só o painel do layout atual é montado — ver o comentário do `v-if` no template. */
const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY)

function setTimeInput(key: string, element: unknown): void {
  if (element instanceof HTMLInputElement) timeInputs.set(key, element)
  else timeInputs.delete(key)
}

/**
 * O `focusin` de um `.focus()` do próprio código é indistinguível do de um toque
 * (`isTrusted` é `true` nos dois), então a marca vem daqui: enquanto este sinal
 * está ligado, o foco é NOSSO e não conta como digitação.
 */
let programmaticFocus = false

/**
 * No celular o carrossel é `sticky` no topo do corpo do modal e ocupa ~330 px
 * (~260 px no recorte). Sem isto, focar o check-in deixava o campo EMBAIXO do
 * painel: aparecia só a dica "Confira com o anexo acima", e a pessoa digitava
 * às cegas. Duas defesas complementares:
 *
 * - `scroll-margin-top` do tamanho do painel + 12 px, medido de verdade, para o
 *   Tab entre os campos (rolagem do próprio navegador) já parar abaixo dele;
 * - um `scrollIntoView({ block: 'center' })` depois do foco, que resolve o caso
 *   em que o campo já estava na tela mas atrás do painel.
 *
 * O elemento que rola é o `<main>` do `Modal.vue` (`overflow-y-auto`); como
 * `scrollIntoView` sobe sozinho por todos os ancestrais roláveis, ele serve
 * tanto para o corpo do modal quanto para a janela, quando o modal não rola.
 */
function keepInputVisible(input: HTMLInputElement): void {
  if (isDesktop.value) return

  const panelHeight = mobilePanel.value?.getBoundingClientRect().height ?? 0
  if (panelHeight) input.style.scrollMarginTop = `${Math.round(panelHeight) + 12}px`

  if (typeof input.scrollIntoView !== 'function') return
  const reduceMotion =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

  input.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' })
}

function focusLeg(doctorStationId: number, coveredLegs: CoveredLegs): void {
  const field = coveredLegs === CoveredLegs.CHECKOUT ? 'declaredCheckout' : 'declaredCheckin'
  void nextTick(() => {
    const input = timeInputs.get(`${field}-${doctorStationId}`)
    programmaticFocus = true
    try {
      input?.focus()
    } finally {
      programmaticFocus = false
    }
    if (input) void nextTick(() => keepInputVisible(input))
  })
}

onMounted(() => {
  const first = props.lines[0]
  if (first) focusLeg(first.doctorStationId, first.coveredLegs)
})

function timeInputOf(target: EventTarget | null): HTMLInputElement | null {
  return target instanceof HTMLInputElement && target.type === 'time' ? target : null
}

function setTyping(value: boolean): void {
  if (isTyping.value === value) return
  isTyping.value = value
}

/**
 * O foco automático do `onMounted` não é digitação: ele acontece ANTES de a
 * pessoa tocar na tela, e tratá-lo como tal abriria a etapa já no recorte do
 * horário, escondendo o anexo inteiro que ela ainda não viu. O recorte só liga em
 * interação de verdade — um toque, uma tecla ou o próprio texto digitado. O
 * cartão em destaque, esse sim, acompanha qualquer foco.
 */
function handleFocusIn(event: FocusEvent): void {
  const input = timeInputOf(event.target)
  if (!input) return
  const line = props.lines.find((item) => input.id.endsWith(`-${item.doctorStationId}`))
  if (line) activeLineId.value = line.doctorStationId
  if (!programmaticFocus) setTyping(true)
  // Depois do `nextTick` o painel já mudou de altura (inteiro ↔ recorte), então a
  // medida usada aqui é a que vale quando a rolagem acontece.
  void nextTick(() => keepInputVisible(input))
}

/**
 * A troca inteiro ↔ recorte muda a altura do painel: o campo em foco precisa ser
 * recentrado com a medida nova, senão ele reaparece atrás do carrossel.
 */
watch(isTyping, () => {
  const input = timeInputOf(document.activeElement)
  if (!input) return
  void nextTick(() => keepInputVisible(input))
})

function markTypingFromInteraction(event: Event): void {
  if (!timeInputOf(event.target)) return
  setTyping(true)
}

function handleFocusOut(event: FocusEvent): void {
  if (!timeInputOf(event.target)) return
  // Tab de um horário para o outro não fecha o recorte: o teclado continua aberto.
  if (timeInputOf(event.relatedTarget)) return
  setTyping(false)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "grid gap-5 text-left md:grid-cols-[minmax(0,1fr)_340px] md:items-start",
    "data-testid": "send-record-step-4",
    onFocusin: handleFocusIn,
    onFocusout: handleFocusOut,
    onPointerdown: markTypingFromInteraction,
    onKeydown: markTypingFromInteraction,
    onInput: markTypingFromInteraction
  }, [
    (!_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "mobilePanel",
          ref: mobilePanel,
          class: "sticky top-0 z-10 -mx-1 bg-white px-1 pb-2 pt-1"
        }, [
          _createVNode(AttachmentPanel, {
            layout: "carousel",
            files: _ctx.files,
            compact: isTyping.value,
            "tolerance-hint": toleranceHint.value,
            "active-index": _ctx.activeIndex,
            "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => (emit('update:activeIndex', $event)))
          }, null, 8, ["files", "compact", "tolerance-hint", "active-index"])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_1,
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line) => {
        return (_openBlock(), _createElementBlock("div", {
          key: line.doctorStationId,
          class: _normalizeClass(["mt-3 rounded-[10px] border bg-white px-4 py-3.5", 
          line.doctorStationId === activeLineId.value
            ? 'border-primary10 ring-[3px] ring-primary5'
            : 'border-lightGray30'
        ]),
          "data-testid": `send-record-line-${line.doctorStationId}`
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(headOf(line)), 1),
              _createTextVNode(" " + _toDisplayString(whenOf(line)), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["inline-flex flex-none items-center gap-1.5 rounded-full px-2 py-[3px] text-[11.5px] font-bold", stateOf(line).classes])
            }, _toDisplayString(stateOf(line).label), 3)
          ]),
          _createElementVNode("div", {
            class: "mt-2.5 grid gap-2 sm:grid-cols-3",
            role: "radiogroup",
            "aria-label": `Este registro equivale a — plantão ${line.doctorStationId}`
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LEG_OPTIONS, (option) => {
              return _createElementVNode("label", {
                key: option.value,
                class: _normalizeClass(["relative flex cursor-pointer items-start gap-2.5 rounded-[10px] border-[1.5px] px-3 py-2.5", 
              line.coveredLegs === option.value
                ? 'border-primary30 bg-primary5'
                : 'border-lightGray30 bg-white'
            ])
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  class: "absolute inset-0 m-0 h-full w-full cursor-pointer opacity-0",
                  name: `leg-${line.doctorStationId}`,
                  value: option.value,
                  checked: line.coveredLegs === option.value,
                  "aria-describedby": `leg-help-${line.doctorStationId}-${option.value}`,
                  "data-testid": `send-record-leg-${line.doctorStationId}-${option.value}`,
                  onChange: ($event: any) => (updateLeg(line.doctorStationId, option.value))
                }, null, 40, _hoisted_8),
                _createElementVNode("span", {
                  class: _normalizeClass(["mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full border-2", line.coveredLegs === option.value ? 'border-primary30' : 'border-neutral50'])
                }, [
                  (line.coveredLegs === option.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("b", _hoisted_11, _toDisplayString(option.label), 1),
                  _createElementVNode("small", {
                    id: `leg-help-${line.doctorStationId}-${option.value}`,
                    class: "mt-0.5 block text-[11.5px] leading-tight text-neutral50"
                  }, _toDisplayString(option.help), 9, _hoisted_12),
                  _createElementVNode("span", _hoisted_13, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["h-1.5 w-[22px] rounded-[3px]", option.bars[0] ? 'bg-primary30' : 'bg-lightGray30'])
                    }, null, 2),
                    _createElementVNode("i", {
                      class: _normalizeClass(["h-1.5 w-[22px] rounded-[3px]", option.bars[1] ? 'bg-primary30' : 'bg-lightGray30'])
                    }, null, 2)
                  ])
                ])
              ], 2)
            }), 64))
          ], 8, _hoisted_7),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TIME_LEGS, (leg) => {
              return _createElementVNode("div", {
                key: leg.field
              }, [
                _createElementVNode("label", {
                  class: "mb-1.5 flex items-center justify-between text-[12.5px] font-bold text-neutral50",
                  for: `${leg.testidPrefix}-${line.doctorStationId}`
                }, [
                  _createTextVNode(_toDisplayString(leg.label) + " ", 1),
                  _createElementVNode("span", _hoisted_16, " previsto " + _toDisplayString(expectedOf(line, leg.field)), 1)
                ], 8, _hoisted_15),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex h-[46px] items-center gap-2 rounded-lg border-[1.5px] px-3 focus-within:border-primary30 focus-within:ring-4 focus-within:ring-primary30/30", 
                covers(line, leg.covered)
                  ? 'border-neutral50 bg-white text-textPrimary'
                  : 'border-dashed border-lightGray30 bg-gray-50 text-neutral50'
              ])
                }, [
                  _createVNode(_component_v_icon, {
                    icon: leg.covered === _unref(CoveredLegs).CHECKIN ? _unref(mdiLoginVariant) : _unref(mdiLogoutVariant),
                    size: "18",
                    class: "flex-none"
                  }, null, 8, ["icon"]),
                  _createElementVNode("input", {
                    id: `${leg.testidPrefix}-${line.doctorStationId}`,
                    ref_for: true,
                    ref: (el) => setTimeInput(`${leg.field}-${line.doctorStationId}`, el),
                    type: "time",
                    class: "w-full min-w-0 border-0 bg-transparent p-0 text-[22px] font-bold tabular-nums tracking-wide text-inherit outline-none",
                    value: toTimeInput(line[leg.field], line.timezone),
                    disabled: !covers(line, leg.covered),
                    "aria-describedby": `hint-${leg.field}-${line.doctorStationId}`,
                    "data-testid": `${leg.testidPrefix}-${line.doctorStationId}`,
                    onInput: ($event: any) => (updateTime(line.doctorStationId, leg.field, $event))
                  }, null, 40, _hoisted_17),
                  _createElementVNode("span", _hoisted_18, "UTC" + _toDisplayString(line.timezone), 1)
                ], 2),
                (warningFor(line, leg.covered))
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      id: `hint-${leg.field}-${line.doctorStationId}`,
                      class: "mt-1.5 text-[11.5px] text-[#8A6A00]",
                      "data-testid": `send-record-tolerance-warning-${line.doctorStationId}`
                    }, _toDisplayString(warningFor(line, leg.covered)?.text) + ". O registro segue normalmente e entra na fila marcado como divergente para o auditor conferir. ", 9, _hoisted_19))
                  : (!covers(line, leg.covered))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        id: `hint-${leg.field}-${line.doctorStationId}`,
                        class: "mt-1.5 text-[11.5px] italic text-neutral50"
                      }, " Não coberto por este anexo. Fica como o sistema tem. ", 8, _hoisted_20))
                    : (_unref(isLegTimeMissing)(line, leg.covered))
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 2,
                          id: `hint-${leg.field}-${line.doctorStationId}`,
                          class: "mt-1.5 text-[11.5px] font-bold text-[#8A6A00]",
                          "data-testid": `send-record-missing-time-${line.doctorStationId}-${leg.covered}`
                        }, " Informe o horário para continuar ", 8, _hoisted_21))
                      : (leg.covered === _unref(CoveredLegs).CHECKIN)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 3,
                            id: `hint-${leg.field}-${line.doctorStationId}`,
                            class: "mt-1.5 text-[11.5px] text-sucess"
                          }, [
                            _createTextVNode(" ✓ Confira com o anexo "),
                            _hoisted_23,
                            _hoisted_24,
                            _createTextVNode(" · [Tab] vai para o check-out ")
                          ], 8, _hoisted_22))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 4,
                            id: `hint-${leg.field}-${line.doctorStationId}`,
                            class: "mt-1.5 text-[11.5px] italic text-neutral50"
                          }, " Deixe " + _toDisplayString(expectedOf(line, leg.field)) + " se o anexo confirmar a saída no horário. ", 9, _hoisted_25))
              ])
            }), 64))
          ]),
          _createElementVNode("p", {
            class: "mt-2.5 flex flex-wrap items-center gap-1.5 text-xs text-neutral50",
            "data-testid": `send-record-timezone-hint-${line.doctorStationId}`
          }, [
            _createTextVNode(" Horários no fuso da escala (" + _toDisplayString(zoneTitle(line.timezone)) + ", UTC" + _toDisplayString(line.timezone) + ")" + _toDisplayString(timezoneOrigin(line)) + ". ", 1),
            (!isZoneOpen(line))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "font-bold text-primary30 underline",
                  "data-testid": `send-record-timezone-toggle-${line.doctorStationId}`,
                  onClick: ($event: any) => (openZone(line.doctorStationId))
                }, " Plantão em outro fuso? Alterar ", 8, _hoisted_27))
              : _createCommentVNode("", true)
          ], 8, _hoisted_26),
          _withDirectives(_createElementVNode("label", {
            class: "mt-1.5 flex flex-col text-xs text-neutral50",
            for: `send-record-timezone-${line.doctorStationId}`
          }, [
            _createTextVNode(" Fuso do plantão "),
            _createElementVNode("select", {
              id: `send-record-timezone-${line.doctorStationId}`,
              class: "mt-0.5 w-fit rounded border border-gray-200 px-2 py-1 text-sm text-textPrimary",
              value: line.timezone,
              "data-testid": `send-record-timezone-${line.doctorStationId}`,
              onChange: ($event: any) => (updateTimezone(line.doctorStationId, $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timezoneOptions.value, (zone) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: zone.value,
                  value: zone.value
                }, _toDisplayString(zone.title) + " (UTC" + _toDisplayString(zone.value) + ") ", 9, _hoisted_30))
              }), 128))
            ], 40, _hoisted_29)
          ], 8, _hoisted_28), [
            [_vShow, isZoneOpen(line)]
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemLegsOf(line), (systemLeg) => {
              return (_openBlock(), _createElementBlock("div", {
                key: systemLeg.key,
                class: "mt-0.5 flex items-baseline gap-2"
              }, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(systemLeg.label), 1),
                _createElementVNode("b", _hoisted_34, _toDisplayString(systemLeg.time || '—'), 1),
                _createElementVNode("span", _hoisted_35, _toDisplayString(systemLeg.detail), 1),
                _createElementVNode("span", _hoisted_36, _toDisplayString(systemLeg.status), 1)
              ]))
            }), 128))
          ])
        ], 10, _hoisted_3))
      }), 128)),
      _hoisted_37
    ]),
    (_unref(isDesktop))
      ? (_openBlock(), _createBlock(AttachmentPanel, {
          key: 1,
          layout: "side",
          files: _ctx.files,
          "tolerance-hint": toleranceHint.value,
          "active-index": _ctx.activeIndex,
          "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => (emit('update:activeIndex', $event)))
        }, null, 8, ["files", "tolerance-hint", "active-index"]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})